import { forwardRef } from 'react'

import { tv } from 'tailwind-variants'

import { Icon } from '@/components/atoms'

export const userTagVariants = tv({
  slots: {
    containerSlot:
      'align-center flex w-fit flex-row items-center gap-2 rounded-sm border',
    contentSlot: 'align-center flex flex-row items-center gap-1',
    colorIndicatorSlot: 'rounded-xs h-2 w-2',
    optionIndicatorSlot: 'rounded-xs h-2 w-2',
    labelSlot: '',
    iconColorSlot: 'material-symbols-rounded text-caption-lg'
  },
  variants: {
    type: {
      color: {
        containerSlot: 'border-surface-white-300',
        iconColorSlot: 'text-surface-black-50',
        labelSlot: 'text-surface-black-50'
      },
      option: {
        containerSlot: 'border-surface-white-300',
        iconColorSlot: 'text-surface-white-400',
        labelSlot: 'text-surface-white-400'
      }
    },
    size: {
      md: {
        containerSlot: 'px-2 py-1',
        labelSlot: 'text-caption-lg font-semibold'
      },
      sm: {
        containerSlot: 'px-1.5 py-0.5',
        labelSlot: 'text-caption-sm font-bold'
      }
    }
  },
  defaultVariants: {
    type: 'color',
    size: 'md'
  }
})

export interface TUserTagProps {
  color?: string
  label: string
  type: 'color' | 'option'
  size?: 'md' | 'sm'
}

export const UserTag = forwardRef<HTMLDivElement, TUserTagProps>(
  ({ color = '#000000', label, type, size }: TUserTagProps, ref) => {
    const {
      containerSlot,
      contentSlot,
      colorIndicatorSlot,
      labelSlot,
      iconColorSlot
    } = userTagVariants({ type, size })

    return (
      <div className={containerSlot()} ref={ref}>
        <div className={contentSlot()}>
          {type === 'color' && (
            <div
              className={colorIndicatorSlot()}
              style={{ backgroundColor: color }}
            />
          )}
          {type === 'option' && (
            <span className={iconColorSlot()}>density_small</span>
          )}
          <p className={labelSlot()}>{label}</p>
        </div>
        {type === 'color' && <Icon name='delete' color='surface-black-50' />}
      </div>
    )
  }
)

UserTag.displayName = 'UserTag'
